/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import _ from 'lodash';

// TODO: eslint
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let chart = null;

class ClassAveragesChart extends Component {
  componentDidMount() {
    import(/* webpackChunkName: 'c3' */ 'c3').then((c3) => {
      this.c3 = c3.default;
      this.generateChart(this.c3);
    });
  }

  componentDidUpdate() {
    if (this.c3) {
      this.generateChart(this.c3);
    }
  }

  getChartId = () => this.props.chartId || 'result-chart';

  getCategories = () => {
    return _.map(this.props.markedQuestions, (question) => {
      return `Q${question.fullSerial}`;
    });
  };

  getClassData = () => {
    const classAverages = [];
    this.props.markedQuestions.forEach((question) => {
      const average = _.find(this.props.classAverages, {
        question: question.id,
      });
      classAverages.push(average.average || 0);
    });

    return ['Class Average'].concat(classAverages);
  };

  getVcaaData = () => {
    const vcaaAverages = [];
    this.props.markedQuestions.forEach((question) => {
      vcaaAverages.push(question.vcaa_average || 0);
    });
    return ['VCAA Average'].concat(vcaaAverages);
  };

  getColumns = () => {
    const { markedQuestions } = this.props;
    const shouldRenderVcaa = markedQuestions.some((q) => !!q.vcaa_average);
    const columns = [];

    if (shouldRenderVcaa) {
      columns.push(this.getVcaaData());
    }

    columns.push(this.getClassData());

    return columns;
  };

  generateChart = (c3) => {
    const categories = this.getCategories();
    const chartId = this.getChartId();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    chart = c3.generate({
      bindto: `#${chartId} > .chart`,
      data: {
        columns: this.getColumns(),
        types: {
          // 'Class Average': 'bar',
          'VCAA Average': 'bar',
        },
        colors: {
          'Class Average': '#448abf',
          'VCAA Average': '#dfe1e1',
        },
      },
      axis: {
        x: {
          type: 'category',
          categories,
        },
        y: {
          min: 0,
          max: 100,
          padding: {
            top: 0,
            bottom: 0,
          },
          tick: {
            values: [0, 50, 100],
            format(value) {
              return `${value}%`;
            },
          },
        },
      },
      grid: {
        y: {
          show: true,
        },
      },
      tooltip: {
        format: {
          value(value, ratio, label) {
            if (label === 'VCAA Average' && value == 0) {
              return 'N/A';
            }

            return `${value}%`;
          },
        },
      },
    });
  };

  render() {
    return (
      <div id={this.getChartId()} chart-type="result">
        <div className="chart" />
      </div>
    );
  }
}

export default ClassAveragesChart;
